export default {
  otherTiers: {
    en: "Other Tiers in collection",
    ja: "コレクションの他の層"
  }
}
